import { render, staticRenderFns } from "./accidentreport.vue?vue&type=template&id=de386980&scoped=true"
import script from "./accidentreport.vue?vue&type=script&lang=js"
export * from "./accidentreport.vue?vue&type=script&lang=js"
import style0 from "./accidentreport.vue?vue&type=style&index=0&id=de386980&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de386980",
  null
  
)

export default component.exports